import { useEffect, useState } from 'react';
import {
	Accordion,
	AccordionSummary,
	AccordionDetails,
	Typography,
	List,
	ListItem,
	ListItemText,
	Paper,
	useMediaQuery,
	ListItemIcon,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DescriptionIcon from '@mui/icons-material/Description';
import LayersIcon from '@mui/icons-material/Layers';
import { Fab, Dialog } from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import './UpdatesPopUp.css';
import axios from 'axios';
import API_URL from '../../config/api.js';
import { tableToLayerName } from '../../config/layerDictionary.js';

export default function UpdatesPopUp({ drawerOpen = false }) {
	const [open, setOpen] = useState(false);
	const [expanded, setExpanded] = useState(false);
	const isMobile = useMediaQuery('(max-width:768px)'); // mobile/tablet-pequeno
	const isTablet = useMediaQuery('(max-width:1024px)'); // tablet
	const [logs, setLogs] = useState([]);

	useEffect(() => {
		const fetchLogs = async () => {
			const token = JSON.parse(
				atob(localStorage.getItem('token') || '""')
			);

			axios
				.get(`${API_URL}/api/Log`, {
					headers: {
						Authorization: `Bearer ${token}`,
					},
				})
				.then(response => {
					setLogs(response.data);
				})
				.catch(error => {
					console.log(error);
				});
		};

		fetchLogs();
	}, []);

	const handleAccordionChange = (_, isExpanded) => {
		setExpanded(isExpanded);
	};

	const getLogIcon = log => {
		if (log.nomeDocumento) {
			return <DescriptionIcon className="log-icon document-icon" />;
		} else if (log.nomeTabela) {
			return <LayersIcon className="log-icon layer-icon" />;
		}
		return null;
	};

	const getPopUpWidth = () => {
		if (isMobile) return 280;
		if (isTablet) return 300;
		return 375;
	};

	if (isMobile) {
		return (
			<>
				{/* Botão flutuante */}
				<Fab className="fab-button" onClick={() => setOpen(true)}>
					<NotificationsIcon />
				</Fab>

				{/* Modal de atualizações */}
				<Dialog
					open={open}
					onClose={() => setOpen(false)}
					fullWidthgetPopUpWidth 
					maxWidth="sm"
				>
					<div style={{ padding: 16 }}>
						<Typography variant="h6" gutterBottom>
							Atualizações de Upload
						</Typography>
						<List dense>
							{logs.map((log, idx) => (
								<ListItem key={idx} disableGutters>
									<ListItemIcon>
										{getLogIcon(log)}
									</ListItemIcon>
									<ListItemText
										primary={
											log.nomeDocumento ||
											tableToLayerName[log.nomeTabela] ||
											log.nomeTabela
										}
										secondary={new Date(
											log.dataLog
										).toLocaleDateString('pt-BR')}
									/>
								</ListItem>
							))}
						</List>
					</div>
				</Dialog>
			</>
		);
	}

	return (
		<div
			className={`custom-popup-container ${
				drawerOpen ? 'drawer-open' : ''
			}`}
			style={{
				position: 'fixed',
				bottom: 22,
				left: drawerOpen ? 'calc(var(--drawer-width) + 24px)' : 3,
				top: 'auto',
				right: 'auto',
				zIndex: 2000,
				transition: 'left 0.3s ease-in-out, bottom 0.3s ease-in-out',
				display: 'block',
			}}
		>
			<Paper
				elevation={6}
				sx={{
					width: getPopUpWidth(),
					maxHeight: expanded
						? 'calc(93vh - var(--ui-safe-top) - var(--ui-safe-bottom))'
						: 'auto',
					overflow: 'hidden',
					transition: 'all 0.3s ease-in-out',
					borderRadius: 2,
					border: '1px solid rgba(35, 55, 119, 0.2)',
				}}
				className="updates-popup-paper"
			>
				<div className="updates-popup-header">
					<Typography
						variant="subtitle1"
						sx={{ fontWeight: 600, color: '#233777' }}
					>
						Atualizações de Upload
					</Typography>
				</div>
				<Accordion
					elevation={0}
					sx={{ boxShadow: 'none' }}
					expanded={expanded}
					onChange={handleAccordionChange}
					className="updates-accordion"
				>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon className="expand-icon" />}
						className="accordion-summary"
					>
						<Typography variant="body2">
							Ver últimas {logs.length} atualizações
						</Typography>
					</AccordionSummary>
					<AccordionDetails className="accordion-details">
						<List dense className="updates-list">
							{Array.isArray(logs) && logs.length > 0 ? (
								logs.map((log, idx) => (
									<ListItem
										key={idx}
										disableGutters
										className="update-item"
									>
										<ListItemIcon className="log-item-icon">
											{getLogIcon(log)}
										</ListItemIcon>
										<ListItemText
											primary={
												log.nomeDocumento
													? log.nomeDocumento
													: tableToLayerName[
															log.nomeTabela
													  ] || log.nomeTabela
											}
											secondary={
												<span>
													<Typography
														variant="body2"
														component="span"
														sx={{ fontSize: 12 }}
													>
														{new Date(
															log.dataLog
														).toLocaleDateString(
															'pt-BR'
														)}
													</Typography>
													{log.descricao && (
														<>
															<br />
															<Typography
																variant="body2"
																component="span"
																sx={{
																	fontSize: 12,
																	fontStyle:
																		'italic',
																}}
															>
																{log.descricao}
															</Typography>
														</>
													)}
												</span>
											}
										/>
									</ListItem>
								))
							) : (
								<Typography
									variant="body2"
									sx={{ px: 2, py: 1 }}
								>
									Nenhuma atualização disponível.
								</Typography>
							)}
						</List>
					</AccordionDetails>
				</Accordion>
			</Paper>
		</div>
	);
}
